import React, { useState } from 'react';
import { changePassword } from '../GoogleSheetsService';
import NotificationPopup from './NotificationPopup';
import './PasswordModal.css';

const PasswordModal = ({ isOpen, onClose, username }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      setNotification({
        show: true,
        message: 'Mật khẩu mới không khớp',
        type: 'error'
      });
      return;
    }

    // Hiển thị thông báo đang xử lý
    setNotification({
      show: true,
      message: 'Đang xử lý...',
      type: 'loading'
    });

    try {
      const result = await changePassword(username, currentPassword, newPassword);
      
      // Hiển thị thông báo thành công
      setNotification({
        show: true,
        message: 'Đổi mật khẩu thành công',
        type: 'success'
      });

      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      
      // Đóng modal sau 2 giây
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      // Hiển thị thông báo lỗi
      setNotification({
        show: true,
        message: error.message || 'Có lỗi xảy ra khi đổi mật khẩu',
        type: 'error'
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Đổi mật khẩu</h3>
          <button onClick={onClose} className="close-button">Đóng ×</button>
        </div>
        <form onSubmit={handlePasswordChange}>
          <div className="form-group">
            <label>Mật khẩu hiện tại:</label>
            <div className="password-input-container">
              <input
                type={showCurrentPassword ? "text" : "password"}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
              <button 
                type="button" 
                className="toggle-password-button"
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
              >
                {showCurrentPassword ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>Mật khẩu mới:</label>
            <div className="password-input-container">
              <input
                type={showNewPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <button 
                type="button" 
                className="toggle-password-button"
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                {showNewPassword ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>Xác nhận mật khẩu mới:</label>
            <div className="password-input-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button 
                type="button" 
                className="toggle-password-button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" onClick={onClose} className="cancel-button">
              Hủy
            </button>
            <button type="submit" className="submit-button">
              Đổi mật khẩu
            </button>
          </div>
        </form>
      </div>
      <NotificationPopup 
        message={notification.message}
        type={notification.type}
        isVisible={notification.show}
      />
    </div>
  );
};

export default PasswordModal;